export const environment = {
  production: true,
  configFile: 'assets/config/config.json',
  version: '2026-06-30.02',
};
